import { useParamValue } from "PFCore/hooks/use_param_value";

type UseUnreadFilterReturn = {
  isUnreadOnly: boolean;
  setIsUnreadOnly: (value: boolean) => void;
  serialize: (value: boolean) => string;
};

const parseRawUnreadValue = (rawValue: string | null) => rawValue?.toLowerCase() === "true";

export const useUnreadFilter = (): UseUnreadFilterReturn => {
  const { value, setValue, ...useParamValueReturn } = useParamValue("unread", { parse: parseRawUnreadValue });

  return {
    isUnreadOnly: value,
    setIsUnreadOnly: setValue,
    ...useParamValueReturn
  };
};
